import { UsageEventBase } from './usageEventBase';
import { FormGroup } from '@angular/forms';

export class LateFunding extends UsageEventBase {

  billConsolidatedOn: string;
  serviceDescription: string;
  consolidationID: string;
  consolidationInvoiceNumber: string;
  consolidationFunded: string;
  daysToBill: number | any;

  constructor(model: FormGroup) {
    console.log('in  LateFunding constructor');
    super(model);
    this.billConsolidatedOn = model.get('lfGroup.billConsolidatedOn').value;
    this.serviceDescription = model.get('lfGroup.serviceDescription').value;
    this.consolidationID = model.get('lfGroup.consolidationID').value;
    this.consolidationInvoiceNumber = model.get('lfGroup.consolidationInvoiceNumber').value;
    this.consolidationFunded = model.get('lfGroup.consolidationFunded').value;
    this.daysToBill = model.get('lfGroup.daysToBill').value;
  }
}
